import React, { useRef, useState } from 'react';
import { CTAGatsbyLink } from '@components/CTAGatsbyLink';
import { aboutPageData } from '@data-ts/pages/about';
import {
  SectionContainer,
  DiversityText,
  DiversityLogoWrapper,
  DiversityJoinUsText,
  JoinUsImage,
  DiversityTextBox,
  DiversityFlex,
  DiversityLogoBox,
  StyledEqualImage,
  ReadMoreButton,
  ExploreTextPairing,
} from './DiversityAndInclusion.styles';
import { CloudImage } from '@components/CloudImage';
import { Flex } from '@components/Flex';
import { Text } from '@components/typography';
import { Box } from '@components/Box';
import ReactHtmlParser from 'react-html-parser';

export const DiversityAndInclusion = () => {
  const { diversity } = aboutPageData;
  const { readMoreContent } = diversity;
  const sectionRef = useRef<HTMLDivElement>(null);
  const [isReadMoreDiversityContent, onChangeReadMoreDiversityContent] = useState<boolean>(false);
  return (
    <SectionContainer paddingBottom={[0]} backgroundColor="yellow1" style={{ position: 'relative' }}>
      <DiversityFlex justifyContent="center">
        <DiversityTextBox backgroundColor="blue2" paddingY={[8, 10]} paddingX={[6, 0]}>
          <Box>
            <DiversityText tagName="h1" variant="calloutHed40Bold" color="blue6">
              {diversity.title}
            </DiversityText>
            <DiversityText variant="dek20" tagName="p" color="blue6">
              {diversity.body}
            </DiversityText>
            <DiversityText variant="dek20" tagName="p" color="blue6">
              {diversity.pledgeContent}
            </DiversityText>
            <ReadMoreButton
              id="readMore"
              variant="secondary"
              forwardedAs={'button'}
              onClick={() => onChangeReadMoreDiversityContent(!isReadMoreDiversityContent)}
            >
              <Text tagName="span" color="link" variant="featureHed17">
                {`${!isReadMoreDiversityContent ? diversity.readMore : diversity.readLess} >`}
              </Text>
            </ReadMoreButton>
            {isReadMoreDiversityContent ? (
              <Box marginTop={[8]}>
                <DiversityText marginBottom={2} tagName="h1" color="blue6" variant="calloutDek40">
                  {readMoreContent.heading}
                </DiversityText>
                {readMoreContent.readMoreParagraphs.map((item, index) => {
                  return (
                    <Box marginTop={[9]} key={index}>
                      <DiversityText tagName="h2" variant="sectionEyeBrow24" color="blue6">
                        {item.title}
                      </DiversityText>
                      {Array.isArray(item.bodyList)
                        ? item.bodyList.map((item, bodyIndex) => (
                            <DiversityText key={bodyIndex} variant="dek20" tagName="p" color="blue6">
                              {item}
                            </DiversityText>
                          ))
                        : null}
                    </Box>
                  );
                })}
              </Box>
            ) : null}
          </Box>
        </DiversityTextBox>
      </DiversityFlex>
      <DiversityLogoWrapper marginBottom={[8, 12]} marginTop={[6]}>
        <DiversityLogoBox marginRight={[8, 11]}>
          <CloudImage alt="diversity logo" src="about-us/unity-community-logo.png" width="100%" />
        </DiversityLogoBox>
        <DiversityLogoBox>
          <a target="_blank" href="https://equallywed.com" rel="noopener noreferrer">
            {/* TODO: Move to S3, change to styled(CloudImage) and use mild optimization.*/}
            <StyledEqualImage
              src="https://equallywed.com/wp-content/uploads/2017/07/Equally-Wed-Featured-On_250x250.png"
              alt="Featured on Equally Wed"
            />
          </a>
        </DiversityLogoBox>
      </DiversityLogoWrapper>
      <JoinUsImage alt="join us" src="about-us/join-us.jpg" isEagerLoading optimization={'mild'} isResizeDisabled={true} />
      <DiversityJoinUsText flexDirection="column" alignItems="center" paddingX={[6, 0]} paddingY={[10]}>
        <ExploreTextPairing
          title={diversity.joinUsTitle}
          titleVariant="calloutHed32"
          titleTagName="h2"
          titleColor="neutra6"
          body={ReactHtmlParser(diversity.joinUsBody)}
          bodyVariant="dek20"
          bodyColor="neutra6"
          bodyMaxWidth="460px"
          alignment="center"
        />
        <Flex alignItems="center" paddingTop={[6]}>
          <CTAGatsbyLink id="diversityJoinUs" to="/careers" variant="primary" hasChevron={true} typography={'featureHed17'}>
            {diversity.exploreCareers}
          </CTAGatsbyLink>
        </Flex>
      </DiversityJoinUsText>
    </SectionContainer>
  );
};
